import { AuthGuard } from '../../shared/services';
import { StudentsForImpactListRoutes } from './students-for-impact-list/students-for-impact-list.routes';
import { StudentsForImpactDetailsRoutes } from './students-for-impact-details/students-for-impact-details.routes';
import { StudentsForImpactEditionRoutes } from './students-for-impact-edit/students-for-impact-edition.routes';
import { StudentsForImpactComponent } from './students-for-impact.component';
import { Route } from '@angular/router';

export const StudentsForImpactRoutes: Route[] = [
  {
    path: 'students-for-impact',
    component: StudentsForImpactComponent,
    canActivate: [AuthGuard],
    children: [
      ...StudentsForImpactListRoutes,
      ...StudentsForImpactDetailsRoutes,
      ...StudentsForImpactEditionRoutes
    ]
  }
];
